import React from "react";
import "./App.css";
import { routes } from "@/routes";
import { useRoutes, RouteObject } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

function App() {
  const router = useRoutes(routes as RouteObject[]);
  return (
    <>
      {router}
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
}

export default App;
